export default {"src":"/_next/static/media/blurred-gradient-background.94b6eb0f.svg","height":650,"width":1920};